import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from '../constants'

export const UpsellProjectsTasks = () => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_tasks}
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource={ProjectsUpsellRequestSources.tasks}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.tasks')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
